import Chart from 'chart.js'
/* eslint-disable complexity, max-statements */
// Função de desenho portada de terceiros (override do Rectangle do Chart.js);
// complexidade/tamanho são inerentes ao desenho em canvas.
// https://github.com/jedtrow/Chart.js-Rounded-Bar-Charts/blob/master/Chart.roundedBarCharts.js
// https://github.com/chartjs/Chart.js/issues/3072
/*
 *   Rounded Rectangle Extension for Bar Charts and Horizontal Bar Charts
 *   Tested with Charts.js 2.7.0
 */
Chart.elements.Rectangle.prototype.draw = function () {
  const ctx = this._chart.ctx
  const vm = this._view
  let left, right, top, bottom, signX, signY, borderSkipped
  let borderWidth = vm.borderWidth

  // If radius is less than 0 or is large enough to cause drawing errors a max
  //      radius is imposed. If cornerRadius is not defined set it to 0.
  let cornerRadius = this._chart.config.options.cornerRadius
  if (cornerRadius < 0) {
    cornerRadius = 0
  }
  if (typeof cornerRadius === 'undefined') {
    cornerRadius = 0
  }

  // Opt-in: em barras horizontais empilhadas, arredonda só os cantos EXTERNOS
  // (extremidade que toca o início/fim do eixo), deixando a junção entre
  // segmentos reta. Outros gráficos não setam a flag → comportamento original.
  const cornerRadiusOuterOnly =
    this._chart.config.options.cornerRadiusOuterOnly === true

  if (!vm.horizontal) {
    // bar
    left = vm.x - vm.width / 2
    right = vm.x + vm.width / 2
    top = vm.y
    bottom = vm.base
    signX = 1
    signY = bottom > top ? 1 : -1
    borderSkipped = vm.borderSkipped || 'bottom'
  } else {
    // horizontal bar
    left = vm.base
    right = vm.x
    top = vm.y - vm.height / 2
    bottom = vm.y + vm.height / 2
    signX = right > left ? 1 : -1
    signY = 1
    borderSkipped = vm.borderSkipped || 'left'
  }

  // Canvas doesn't allow us to stroke inside the width so we can
  // adjust the sizes to fit if we're setting a stroke on the line
  if (borderWidth) {
    // borderWidth shold be less than bar width and bar height.
    const barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom))
    borderWidth = borderWidth > barSize ? barSize : borderWidth
    const halfStroke = borderWidth / 2
    // Adjust borderWidth when bar top position is near vm.base(zero).
    const borderLeft = left + (borderSkipped === 'left' ? 0 : halfStroke * signX)
    const borderRight =
      right + (borderSkipped === 'right' ? 0 : -halfStroke * signX)
    const borderTop = top + (borderSkipped === 'top' ? 0 : halfStroke * signY)
    const borderBottom =
      bottom + (borderSkipped === 'bottom' ? 0 : -halfStroke * signY)
    // not become a vertical line?
    if (borderLeft !== borderRight) {
      top = borderTop
      bottom = borderBottom
    }
    // not become a horizontal line?
    if (borderTop !== borderBottom) {
      left = borderLeft
      right = borderRight
    }
  }

  ctx.beginPath()
  ctx.fillStyle = vm.backgroundColor
  ctx.strokeStyle = vm.borderColor
  ctx.lineWidth = borderWidth

  // Corner points, from bottom-left to bottom-right clockwise
  // | 1 2 |
  // | 0 3 |
  const corners = [
    [left, bottom],
    [left, top],
    [right, top],
    [right, bottom],
  ]

  // Find first (starting) corner with fallback to 'bottom'
  const borders = ['bottom', 'left', 'top', 'right']
  let startCorner = borders.indexOf(borderSkipped, 0)
  if (startCorner === -1) {
    startCorner = 0
  }

  function cornerAt(index) {
    return corners[(startCorner + index) % 4]
  }

  // Draw rectangle from 'startCorner'
  let corner = cornerAt(0)
  ctx.moveTo(corner[0], corner[1])

  let nextCornerId = null
  for (let i = 1; i < 4; i++) {
    corner = cornerAt(i)
    nextCornerId = i + 1
    if (nextCornerId === 4) {
      nextCornerId = 0
    }

    let width = corners[2][0] - corners[1][0]
    let height = corners[0][1] - corners[1][1]
    let x = corners[1][0]
    let y = corners[1][1]

    let radius = cornerRadius
    // Fix radius being too large
    if (radius > Math.abs(height) / 2) {
      radius = Math.floor(Math.abs(height) / 2)
    }
    if (radius > Math.abs(width) / 2) {
      radius = Math.floor(Math.abs(width) / 2)
    }

    if (height < 0) {
      // Negative values in a standard bar chart
      let x_tl = x
      let x_tr = x + width
      let y_tl = y + height
      let y_tr = y + height

      let x_bl = x
      let x_br = x + width
      let y_bl = y
      let y_br = y

      // Draw
      ctx.moveTo(x_bl + radius, y_bl)
      ctx.lineTo(x_br - radius, y_br)
      ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius)
      ctx.lineTo(x_tr, y_tr + radius)
      ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr)
      ctx.lineTo(x_tl + radius, y_tl)
      ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius)
      ctx.lineTo(x_bl, y_bl - radius)
      ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl)
    } else if (width < 0) {
      // Negative values in a horizontal bar chart
      let x_tl = x + width
      let x_tr = x
      let y_tl = y
      let y_tr = y

      let x_bl = x + width
      let x_br = x
      let y_bl = y + height
      let y_br = y + height

      // Draw
      ctx.moveTo(x_bl + radius, y_bl)
      ctx.lineTo(x_br - radius, y_br)
      ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius)
      ctx.lineTo(x_tr, y_tr + radius)
      ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr)
      ctx.lineTo(x_tl + radius, y_tl)
      ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius)
      ctx.lineTo(x_bl, y_bl - radius)
      ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl)
    } else if (vm.horizontal && cornerRadiusOuterOnly) {
      // Barra horizontal: arredonda só os cantos da extremidade que toca o
      // início (esquerda) e/ou o fim (direita) da área do gráfico. A junção
      // entre o preenchimento e a trilha fica reta.
      const area = this._chart.chartArea
      const roundLeft = Math.abs(x - area.left) <= 1
      const roundRight = Math.abs(x + width - area.right) <= 1
      const rTL = roundLeft ? radius : 0
      const rBL = roundLeft ? radius : 0
      const rTR = roundRight ? radius : 0
      const rBR = roundRight ? radius : 0
      ctx.moveTo(x + rTL, y)
      ctx.lineTo(x + width - rTR, y)
      ctx.quadraticCurveTo(x + width, y, x + width, y + rTR)
      ctx.lineTo(x + width, y + height - rBR)
      ctx.quadraticCurveTo(x + width, y + height, x + width - rBR, y + height)
      ctx.lineTo(x + rBL, y + height)
      ctx.quadraticCurveTo(x, y + height, x, y + height - rBL)
      ctx.lineTo(x, y + rTL)
      ctx.quadraticCurveTo(x, y, x + rTL, y)
    } else {
      // Positive Value
      ctx.moveTo(x + radius, y)
      ctx.lineTo(x + width - radius, y)
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
      ctx.lineTo(x + width, y + height - radius)
      ctx.quadraticCurveTo(
        x + width,
        y + height,
        x + width - radius,
        y + height
      )
      ctx.lineTo(x + radius, y + height)
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
      ctx.lineTo(x, y + radius)
      ctx.quadraticCurveTo(x, y, x + radius, y)
    }
  }

  ctx.fill()
  if (borderWidth) {
    ctx.stroke()
  }
}